<template>
  <nav
    v-if="!$route.meta.hideHeader"
    class="navbar"
    role="navigation"
    aria-label="main navigation"
  >
    <b-dropdown
      aria-role="list"
      class="is-hidden-desktop is-pulled-right"
    >
      <button
        slot="trigger"
        class="button"
      >
        <span>Menu</span>
        <span class="icon-static small chevron-down" />
      </button>

      <b-dropdown-item aria-role="listitem">
        <router-link
          :to="{ name: 'ai-track-search' }"
          class="navbar-item"
        >
          <sparkle-icon class="nav-sparkle" />
          <span class="title is-5">AI Search</span>
        </router-link>
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem">
        <router-link
          :to="{ name: 'track-search' }"
          class="navbar-item"
        >
          <span class="title is-5">Tracks</span>
        </router-link>
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem">
        <router-link
          :to="{ name: 'playlist-list' }"
          class="navbar-item"
        >
          <span class="title is-5">Playlists</span>
        </router-link>
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem">
        <router-link
          :to="{ name: 'pricing' }"
          class="navbar-item"
        >
          <span class="title is-5">Pricing</span>
        </router-link>
      </b-dropdown-item>
      <b-dropdown-item
        aria-role="listitem"
      >
        <router-link
          :to="{ name: 'sfx-search' }"
          class="navbar-item"
        >
          <span class="title is-5">Sfx</span>
          <span class="tag new">New</span>
        </router-link>
      </b-dropdown-item>
      <b-dropdown-item>
        <div class="navbar-item">
          <div class="buttons">
            <a
              v-if="showAdditionalPricingLink"
              class="button is-accent is-small"
              @click="$store.dispatch('common/startSignupWorkflow')"
            >
              {{ $store.getters['subscriptions/signupButtonLabel'] }}
            </a>
            <a
              v-if="!isLoggedIn"
              class="button is-accent is-small"
              @click="handleSignupClick"
            >{{ authPagesEnabled ? 'Create free account' : $store.getters['subscriptions/signupButtonLabel'] }}</a>
            <a
              v-if="!isLoggedIn"
              class="button is-secondary is-small"
              @click="$store.dispatch('auth/showLoginModal')"
            >Log in</a>
            <router-link
              v-if="isLoggedIn"
              :to="{ name: 'profile-edit' }"
            >
              <span class="icon-button medium nav-user" />
            </router-link>
            <router-link
              v-if="isLoggedIn"
              :to="{ name: 'favourite-tracks' }"
              style="margin: 0 0px 0 20px; position: relative;"
            >
              <span class="icon-button medium nav-heart" />
              <span
                class="badge"
                style="position: absolute; right: -6px;"
              >{{ $store.getters['favouriteTracks/favouritesCount'] }}</span>
            </router-link>
            <router-link
              :to="{ name: 'cart' }"
              style="margin: 0 20px 0 20px; position: relative;"
            >
              <span class="icon-button medium nav-cart" />
              <span
                v-if="$store.getters['cart/cartCount'] > 0"
                class="badge primary"
                style="position: absolute; right: -6px;"
              >{{ $store.getters['cart/cartCount'] }}</span>
            </router-link>
          </div>
        </div>
      </b-dropdown-item>
    </b-dropdown>
    <div
      class="navbar-brand"
      style="width: 200px;"
    >
      <router-link
        :to="{ name: 'home' }"
        class="navbar-item"
      >
        <img
          src="@/assets/sonata-logo.svg"
          alt="Sonata"
          width="112"
          height="30"
        >
      </router-link>
    </div>

    <div class="navbar-menu">
      <div class="navbar-start">
        <router-link
          :to="{ name: 'ai-track-search' }"
          class="navbar-item"
        >
          <sparkle-icon class="nav-sparkle" />
          <span class="title is-5">AI Search</span>
        </router-link>
        <router-link
          :to="{ name: 'track-search' }"
          class="navbar-item"
        >
          <span class="title is-5">Tracks</span>
        </router-link>
        <router-link
          :to="{ name: 'playlist-list' }"
          class="navbar-item"
        >
          <span class="title is-5">Playlists</span>
        </router-link>
        <router-link
          :to="{ name: 'pricing' }"
          class="navbar-item"
        >
          <span class="title is-5">Pricing</span>
        </router-link>
        <router-link
          :to="{ name: 'sfx-search' }"
          class="navbar-item"
        >
          <span class="title is-5">Sfx</span>
          <span class="tag new">New</span>
        </router-link>
      </div>

      <div class="navbar-end">
        <div class="navbar-item">
          <div class="buttons">
            <a
              v-if="showAdditionalPricingLink"
              class="button is-accent is-small"
              @click="$store.dispatch('common/startSignupWorkflow')"
            >
              {{ $store.getters['subscriptions/signupButtonLabel'] }}
            </a>
            <a
              v-if="!isLoggedIn"
              class="button is-accent is-small"
              @click="handleSignupClick"
            >{{ authPagesEnabled ? 'Create free account' : $store.getters['subscriptions/signupButtonLabel'] }}</a>
            <a
              v-if="!isLoggedIn"
              class="button is-secondary is-small"
              @click="$store.dispatch('auth/showLoginModal')"
            >Log in</a>
            <router-link
              v-if="isLoggedIn"
              :to="{ name: 'profile-edit' }"
            >
              <span class="icon-button medium nav-user" />
            </router-link>
            <router-link
              v-if="isLoggedIn"
              :to="{ name: 'favourite-tracks' }"
              style="margin: 0 0px 0 20px; position: relative;"
            >
              <span class="icon-button medium nav-heart" />
              <span
                class="badge"
                style="position: absolute; right: -6px;"
              >{{ $store.getters['favouriteTracks/favouritesCount'] }}</span>
            </router-link>
            <router-link
              :to="{ name: 'cart' }"
              style="margin: 0 20px 0 20px; position: relative;"
            >
              <span class="icon-button medium nav-cart" />
              <span
                v-if="$store.getters['cart/cartCount'] > 0"
                class="badge primary"
                style="position: absolute; right: -6px;"
              >{{ $store.getters['cart/cartCount'] }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import SparkleIcon from '@/components/SparkleIcon.vue'
import { formatComponentName } from '@/utils/common.js'
import { AUTH_PAGES_SWITCH } from '@/utils/authPages.js'

export default {
  name: 'TheHeader',

  components: {
    SparkleIcon
  },

  computed: {
    ...mapGetters({ isFeatureEnabled: 'waffle/isFeatureEnabled' }),

    isLoggedIn: function () {
      return this.$store.getters['auth/isLoggedIn']
    },

    authPagesEnabled: function () {
      return this.isFeatureEnabled(AUTH_PAGES_SWITCH)
    },

    componentName: function () {
      return formatComponentName(this)
    },

    showAdditionalPricingLink: function () {
      const freeTrialMode = this.$store.getters['subscriptions/createSubscriptionWithTrial']
      const currentSubscription = this.$store.getters['subscriptions/currentSubscription']

      if (!freeTrialMode) {
        return false
      }
      if (!this.isLoggedIn) {
        return false
      }

      return !currentSubscription
    }
  },

  methods: {
    handleSignupClick () {
      if (this.authPagesEnabled) {
        this.$store.dispatch('user/showSignupModal')
      } else {
        this.$store.dispatch('common/startSignupWorkflow')
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../assets/scss/_variables.scss";
  .tag {
    &.new {
      margin-left: 4px;
      font-size: 8px;
      letter-spacing: 0.07em;
      padding: 4px;
      border: 1px solid $green !important;
      background: white !important;
      color: $green;
      height: 14px;
      text-transform: uppercase;
    }
  }
  .nav-sparkle {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
</style>
